import { IconButton } from "@chakra-ui/react";
import { AlertsContext } from "providers/alerts";
import { useContext, useState } from "react";
import { apiRequest } from "utils/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getErrorMessage } from "utils/errorHandler";

const InviteButton = ({ id }: { id: string }) => {
  const { showSuccess, showError } = useContext(AlertsContext);
  const [loading, setLoading] = useState(false);

  const sendInvite = async (id: string) => {
    try {
      setLoading(true);
      await apiRequest("/supabase/users/invite", {
        id: id,
      });
      showSuccess({
        title: "Account Invite Sent",
        description: "An email has been sent to create an account.",
      });
    } catch (error) {
      showError({
        title: "Something went wrong.",
        description: getErrorMessage(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <IconButton
      ml="16px"
      variant="whiteIconOutline"
      maxW="34px"
      minW="34px"
      h="34px"
      aria-label="invite-member"
      isLoading={loading}
      onClick={() => sendInvite(id)}
      icon={<FontAwesomeIcon icon={["far", "envelope"]} fontSize="14px" />}
    />
  );
};

export default InviteButton;
